import api from "../api";

type credentialsType = {
	student_id: string;
	institution: string;
	dob: string;
};

// type cardInformation = {
// 	education_level: string;
// 	uf: string;
// 	city: string;
// 	name: string;
// 	cpf: string;
// 	rg: string;
// 	photo: any;

// 	dob: string;
// 	institution: string;
// 	student_id: string;
// 	position: string;

// 	course?: string;
// };

export default class CreateCardApi {
	getInstitutions() {
		return api.get("/landing_page/get_institutions");
	}
	getCard() {
		return api.get("/users/profile/get_card");
	}
	getCardV2(id: string) {
		return api.post("/users/profile/get_card_v2", { aggregate_token: id });
	}
	checkCredentials(data: credentialsType) {
		return api.post("/landing_page/check_credentials", data);
	}
	postCard(data) {
		return api.post("/landing_page/register_card", data);
	}
}
